import permissionService from '@app/services/permissionService'

import { getFilteredMenuItemGroup } from './getFilteredMenuItemGroup'
import { getMenuItemGroup } from './getMenuItemGroup'

import type { MenuItemGroup } from '@app/types/menu'
import type { GetMenuItemGroupsParams, HasPermissionsParams } from './types'

const hasPermissions = ({ userRoles, rawMenuItem }: HasPermissionsParams): boolean => {
  const { requiredRoles, requiredPermissions } = rawMenuItem

  return permissionService.checkAccess({ userRoles, requiredRoles, requiredPermissions })
}

export const getMenuItemGroups = ({ userRoles, rawMenuItemGroups }: GetMenuItemGroupsParams): MenuItemGroup[] =>
  rawMenuItemGroups
    .map(rawMenuItemGroup =>
      getMenuItemGroup(
        getFilteredMenuItemGroup(rawMenuItemGroup, rawMenuItem => hasPermissions({ userRoles, rawMenuItem }))
      )
    )
    .filter(item => !!item.children?.length)
